/** Square icon with "GIF" text - used for GIF picker button */
export function GifIcon({ className = 'h-5 w-5' }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center justify-center font-bold text-[9px] rounded border border-current ${className}`}
      style={{ minWidth: 20, minHeight: 20 }}
    >
      GIF
    </span>
  );
}
